export const DEPARTMENT_OPTIONS = [
  { label: 'Support',      labelAr: 'الدعم الفني',    value: 'support@vitaloapp.com' },
  { label: 'Billing',      labelAr: 'الفواتير',        value: 'billing@vitaloapp.com' },
  { label: 'Marketing',    labelAr: 'التسويق',          value: 'marketing@vitaloapp.com' },
  { label: 'Partnerships', labelAr: 'الشراكات',         value: 'partnerships@vitaloapp.com' },
  { label: 'Investors',    labelAr: 'المستثمرون',       value: 'investors@vitaloapp.com' },
  { label: 'Privacy',      labelAr: 'الخصوصية',         value: 'privacy@vitaloapp.com' },
  { label: 'Info',         labelAr: 'معلومات عامة',     value: 'info@vitaloapp.com' },
  { label: 'Other',        labelAr: 'اخرى',             value: 'other' },
] as const;

export const contactTranslations = {
  en: {
    title: 'Contact Vitalo',
    subtitle: 'Have a question or feedback? We\'d love to hear from you.',
    form: {
      name: {
        label: 'Full Name',
        placeholder: 'Your name',
        required: 'Name is required',
      },
      email: {
        label: 'Email Address',
        placeholder: 'Your email',
        required: 'Email is required',
        invalid: 'Please enter a valid email address',
      },
      department: {
        label: 'Department',
        placeholder: 'Select a department',
        required: 'Please select a department',
      },
      otherSubject: {
        label: 'Subject',
        placeholder: 'Briefly describe your subject',
        required: 'Please enter a subject',
      },
      message: {
        label: 'Message',
        placeholder: 'Your message…',
        required: 'Message is required',
        maxLength: 'Message must be 2000 characters or less',
      },
      submit: 'Send Message',
      submitting: 'Sending...',
    },
    success: {
      title: 'Thanks, we\'ve got it!',
      message: 'We\'ve received your message and will get back to you soon.',
      sendAnother: 'Send another message',
    },
    errors: {
      generic: 'Something went wrong. Please try again.',
      spam: 'Please wait a moment before submitting.',
    },
    faq: {
      title: 'Frequently Asked Questions',
      items: [
        {
          question: 'How quickly do you respond?',
          answer: 'We typically respond within 24 hours during business days.',
        },
        {
          question: 'Is my data secure?',
          answer: 'Yes, we take privacy seriously. Your data is encrypted and never shared with third parties.',
        },
        {
          question: 'Can I delete my account?',
          answer: 'Absolutely. You can delete your account and all associated data at any time from your settings.',
        },
      ],
    },
  },
  ar: {
    title: 'تواصل مع فيتالو',
    subtitle: 'لديك سؤال أو ملاحظة؟ نحن نحب أن نسمع منك.',
    form: {
      name: {
        label: 'الاسم الكامل',
        placeholder: 'اسمك',
        required: 'الاسم مطلوب',
      },
      email: {
        label: 'البريد الإلكتروني',
        placeholder: 'بريدك الإلكتروني',
        required: 'البريد الإلكتروني مطلوب',
        invalid: 'يرجى إدخال بريد إلكتروني صحيح',
      },
      department: {
        label: 'القسم',
        placeholder: 'اختر القسم',
        required: 'يرجى اختيار القسم',
      },
      otherSubject: {
        label: 'الموضوع',
        placeholder: 'اكتب موضوع رسالتك باختصار',
        required: 'يرجى إدخال موضوع الرسالة',
      },
      message: {
        label: 'الرسالة',
        placeholder: 'رسالتك…',
        required: 'الرسالة مطلوبة',
        maxLength: 'يجب أن تكون الرسالة 2000 حرف أو أقل',
      },
      submit: 'إرسال الرسالة',
      submitting: 'جاري الإرسال...',
    },
    success: {
      title: 'شكرًا، تم استلام رسالتك!',
      message: 'تم استلام رسالتك وسنرد عليك قريبًا.',
      sendAnother: 'أرسل رسالة أخرى',
    },
    errors: {
      generic: 'حدث خطأ. يرجى المحاولة مرة أخرى.',
      spam: 'يرجى الانتظار قليلاً قبل الإرسال.',
    },
    faq: {
      title: 'الأسئلة الشائعة',
      items: [
        {
          question: 'كم سرعة ردكم؟',
          answer: 'نرد عادة خلال 24 ساعة في أيام العمل.',
        },
        {
          question: 'هل بياناتي آمنة؟',
          answer: 'نعم، نحن نأخذ الخصوصية على محمل الجد. بياناتك مشفرة ولا نشاركها مع أطراف ثالثة أبدًا.',
        },
        {
          question: 'هل يمكنني حذف حسابي؟',
          answer: 'بالطبع. يمكنك حذف حسابك وجميع البيانات المرتبطة به في أي وقت من الإعدادات.',
        },
      ],
    },
  },
};
